module.exports = __webpack_public_path__ + "img/Folded_Paper_agile_design.a0fc8aa5.svg";